
import * as AllGames from "../index.js"; // this gives you access to BinaryTreeIntroduction, etc.

export const getQueueGame = (subcategory, stage) => {
    if (subcategory === "Circular Queue") {
        switch (stage.name.toLowerCase()) {
            case "introduction":
                return <AllGames.CircularQueueIntro />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }
    else if (subcategory === "Heap") {
        switch (stage.name.toLowerCase()) {
            case "introduction":
                return <AllGames.HeapIntro />;
            default:
                return <p style={{ color: "black" }}>Παιχνίδι δεν βρέθηκε.</p>;
        }
    }

    return <p style={{ color: "black" }}>Δεν υποστηρίζεται αυτό το δέντρο.</p>;
};
